import { memo } from 'react';
import { IconButton, styled, Tooltip } from '@mui/material';
import SmartButton from '@mui/icons-material/SmartButton';
import type { CellContext } from '@tanstack/react-table';

import { ContextMenuButton } from '../ContextMenuButton';
import type { ContextMenuItem } from 'utils/hooks/userAgendaTable/useAgendaContextMenu';

const Wrapper = styled('div')(() => ({
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
}));

interface Props<T, P> {
  row: CellContext<T, P>;
  contextMenuItems: ContextMenuItem[];
}

const ButtonBase = <T, P>({ row, contextMenuItems }: Props<T, P>) => {
  const directItems = contextMenuItems.filter((item) => item.showButtonDirectly);
  const dropdownItems = contextMenuItems.filter((item) => !item.showButtonDirectly);

  return (
    <Wrapper>
      {directItems.map((item) => (
        <Tooltip key={`${row.row.id}-${item.name}`} title={item.name}>
          <IconButton
            aria-label={item.name}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              item.changeBehavior((row.row.original as Record<string, string>)?.id);
            }}>
            <SmartButton fontSize="small" />
          </IconButton>
        </Tooltip>
      ))}
      {dropdownItems.length > 0 && (
        <ContextMenuButton
          row={row}
          menuItems={dropdownItems.map((item) => ({ label: item.name, action: item.changeBehavior }))}
          onClick={(rowData, _, action) => {
            action?.((rowData as Record<string, string>)?.id);
          }}
        />
      )}
    </Wrapper>
  );
};

export const ButtonHelios = memo(ButtonBase) as typeof ButtonBase;
